import React from 'react'
import { Container, TextareaAutosize } from '@mui/material'

import { Fab } from '@mui/material'

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
const TodoList = () => {
  return (
    <div className='flex flex-col gap-8 h-screen justify-center items-center'>   
    <h3 className='text-gray-800 text-3xl'>
    Schedule your task to make life easier
    </h3>
    <Container className='mb-2' maxWidth="sm">
    <div className='w-[500px] h-[50px] bg-blue-300 mb-2 rounded-sm  flex'>
    
        <h1 className='p-1'>1.Complete fair record by 10PM</h1>
        <i class="fa-solid fa-circle-trash"></i>
        <EditIcon className='p-1'/>
        <input type='checkbox' className='p-1 mt-2'></input>
    
    </div>
    <div className='w-[500px] h-[50px] bg-blue-300 mb-2 rounded-sm  flex'>
    
        <h1 className='p-1'>2.Complete Homework by 11.30PM</h1>
        <i class="fa-solid fa-circle-trash"></i>
        <EditIcon className='p-1'/>
        <input type='checkbox' className='p-1 mt-2'></input>
    
    </div>
    <h2>Add New</h2>
    <TextareaAutosize 
    aria-label="Title"
    placeholder="Title"
    style={{ width: 300 }}
  />
  <TextareaAutosize
        aria-label="brief"
        minRows={3}
        placeholder="Description"
        style={{ width: 300 }}
      />
    </Container>
    <Fab color="primary" aria-label="add">
  <AddIcon />
</Fab>
    </div>
  )
}

export default TodoList